require('jquery-ui/ui/widgets/draggable.js');
require('jquery-ui/ui/position.js');
require('fullcalendar/dist/fullcalendar.js');
require('fullcalendar/dist/locale-all.js');

require('esn-frontend-common-libs/src/frontend/vendor-libs.js');
require('esn-frontend-mailto-handler/src/index.js');
require('esn-frontend-videoconference-calendar/src/index.js');

require('./app/app.js');

require('./all.less');
